import {Component, EventEmitter, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {TaskOptionsService} from '../../../../services/task-options.service';
import {ModalService} from '../../../../services/modal/modal.service';
import {CrmService} from '../../../../services/api/crm.service';
import {AlertService} from '../../../../services/notify/alert.service';
import {BoardTableModel, StatusNodeModel, TaskBoardModel} from '../../../../models/tasktable.model';
import {GraphServiceService} from '../../../../services/graph-service.service';
import {TranslateService} from '@ngx-translate/core';
import {GraphKnDataService} from '../../../../modules/graph-konva/services/graph-kn.data.service';
import {
    BUSINESS_PROCESS_LAYER_ID,
    CONTRACT_LAYER_ID,
    DagreNodesOnlySettings,
    IKnUIOptions,
    IStageSettings,
    TIconsType,
    TLayerIDs
} from '../../../../modules/graph-konva/models/graph-kn.cm-api-models';
import {Edges} from '../../../../models/graph.model';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { Edge, IGraphData, IGraphNode } from '../../../../modules/graph-konva/models/graph-kn.model-interfaces';
import { EdgePointerType, EEdgyType, ELayoutAlgorithms } from '../../../../modules/graph-konva/models/graph-kn.model-enums';
import { MatDialog } from '@angular/material/dialog';
import { AppTaskNodeCreateFormComponent } from '../forms/task-node-create-edit-form/task-node-create-edit-form';


@Component({
    selector: 'app-task-boards',
    templateUrl: './task-boards.component.html',
    styleUrls: ['./task-boards.component.scss'],
})
export class TaskBoardsComponent implements OnInit {
    @ViewChild('deleteStatusNode') public deleteStatusNode!: TemplateRef<any>;
    @ViewChild('settingsNodeView') public settingsNodeView!: TemplateRef<any>;
    isDeleteMode = false;

    allBoards: any;
    statusesOfDeletedBoard: any;

    isShow = false;

    selectedStatus: any;
    deleteStatus: any;
    boardWithDeletingStatus: any;

    /**
     * Шаг визарда при создании связи между досками
     * value = { selectBoard / selectStatus / selectTargetBoard }
     */
    step = 'selectBoard';

    inputBoards: BoardTableModel[] = [];

    outputDashboard: TaskBoardModel|null = null;
    outputStatus: StatusNodeModel|null = null;
    inputDashboard: TaskBoardModel|null = null;

    isLockButton = false;
    isShowIcons = false;
    graphData: IGraphData = {
        nodes: [],
        edges: [],
    };
    public layoutDagreSettings: Map<TLayerIDs, DagreNodesOnlySettings> = new Map([
        [BUSINESS_PROCESS_LAYER_ID,
            {
                module:ELayoutAlgorithms.ELK,  
                algorithmEdges:ELayoutAlgorithms.ELK,
                edgeType:EEdgyType.Dagre,
                pointerType:EdgePointerType.Arrow,
                ranker: 'layered',
                parent: true,
                rankPadding: 80,
                nodePadding: 50,  
                marginX: 50,
                marginY: window.innerHeight * 0.0,
                heigt: window.innerHeight ,
                width: window.innerWidth -100,
                nodeWidthAdaptive:false
            }
        ]
    ]);
    public stageSettings: IStageSettings = {
        offsetY: -5,
        height: window.innerHeight * 2,
        width: window.innerWidth * 2,
        showSettingsButton:false,
    }
    public graphUISetting: Map<TLayerIDs, IKnUIOptions> = new Map([
        [CONTRACT_LAYER_ID, {}],
        [BUSINESS_PROCESS_LAYER_ID, {
            draggable:false,
            showDetails: false,
            showUsers: false,
            showStatusPanel: false,
            showEdit: false,
            showDelete: false,
            showCreateNode: false,
            showCreateEdge: false,
            showDeleteEdge: true
        }]
    ]);



    constructor(
        public taskOptionsService: TaskOptionsService,
        public crmService: CrmService,
        public alert: AlertService,
        public modalService: ModalService,
        public graphService: GraphServiceService,
        public translate: TranslateService,
        private knDataService: GraphKnDataService,
        private dialog:MatDialog
    ) {
    }

    ngOnInit(): void {
        this.taskOptionsService.init();
        this.openGraph();
    }

    openGraph(): void {
        this.graphData.nodes = [];
        this.graphData.edges = [];
        this.crmService.getBoardsForGraph().subscribe({
            next: res => {
                this.allBoards = res.boards;
                res.boards.filter((board:any) => board.board_links.length).map((board:any) => {
                    if (!this.graphData.nodes.filter(node => node.id === (board.alias)).length) {
                        const sourceCluster: IGraphNode = {
                            id: board.alias,
                            label: '#' + board.alias + ' ' + board.name,
                            nodeType:'parentBP',
                            dimension:{width:0,height:0},
                            position:{x:0,y:0}
                        };
                        this.graphData.nodes.push(sourceCluster);
                    }

                    board.board_links.map((link:any) => {
                        const targetBoard = res.boards.filter((resBoard:any) =>
                            resBoard.status_nodes.filter((node:any) => node.id === link.target_id).length)[0];
                        if (!this.graphData.nodes.filter(node => node.id === (targetBoard.alias))[0]) {
                            const targetCluster: IGraphNode = {
                                id:  targetBoard.alias,
                                label: '#' + targetBoard.alias + ' ' + targetBoard.name,
                                nodeType:'parentBP',
                                dimension:{width:0,height:0},
                                position:{x:0,y:0}
                            };
                            this.graphData.nodes.push(targetCluster);
                        }
                        if (!this.graphData.nodes.filter(node => node.id === (link.source_id)).length) {
                            const sourceStatus = board.status_nodes.filter((node:any) => node.id === link.source_id)[0];
                            const sourceNode: IGraphNode = {
                                id:  link.source_id,
                                label: sourceStatus.label,
                                parent:  board.alias,
                                bp_status_data: sourceStatus,
                                nodeType:'childBPStatus',
                                dimension:{width:0,height:0},
                                position:{x:0,y:0}
                            };
                            this.graphData.nodes.push(sourceNode);
                        }

                        const targetStatus = targetBoard.status_nodes.filter((node:any) => node.id === link.target_id)[0];
                        
                        const targetNode: IGraphNode = {
                                id:  link.target_id,
                                label: targetStatus.label,
                                parent: targetBoard.alias,
                                bp_status_data: targetStatus,
                                nodeType:'childBPStatus',
                                dimension:{width:0,height:0},
                                position:{x:0,y:0}
                        };
                        this.graphData.nodes.push(targetNode);

                        const edge: Edge = {
                            id: link.id,
                            source: link.source_id,
                            target: link.target_id,
                            points_labels:[]
                        };
                        this.graphData.edges.push(edge);
                    });
                });
                this.knDataService.generateGraphDataBP$.next(this.graphData)
            }, error: err => {
                this.alert.setAlert(err.message, 'blue');
            },
        });
    }
    handleNodeEvent(event: { action: TIconsType, data: IGraphNode }) {
        switch (event.action) {
            case 'VIEW_NODE':
              //  this.graphService.changeNode2(event.data);
                let formRef = this.dialog.open(AppTaskNodeCreateFormComponent)
                formRef.componentInstance.nodeData = event.data 
                formRef.componentInstance.formMode = 'View' 
                break;
        }
    }
    refreshBoards(newBoard : any): void {
        this.taskOptionsService.onLoadBoards(true).then(() => {
            this.crmService.getBoardByAlias(newBoard.alias).subscribe(result => {
                this.outputDashboard = result.board;
            });
        });
    }

    createBoardsLink(modal: NgbModalRef): void {
        const data = {
            status_node_id: this.outputStatus!.id,
            board_alias: this.inputDashboard!.alias,
        };
        this.isLockButton = true;
        this.crmService.createCopyTaskLinkBetweenBoards(data).subscribe({
            next: (res) => {
                this.isLockButton = false;
                this.openStatusSettings(res.status_to);
                this.openGraph();
                this.alert.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'nd_color');
                modal.close();
            }, error: err => {
                this.isLockButton = false;
                this.alert.setAlert(err.message, 'blue');
            },
        });
    }

    openStatusSettings(newStatus: any): void {
        this.graphService.selectBoard(this.inputDashboard!, true, false).then(() => {
          newStatus.data.is_successful = newStatus.is_successful;
          newStatus.data.description = newStatus.description;
          newStatus.data.is_initial = newStatus.is_initial;
          newStatus.data.is_archive = newStatus.is_archive;
          newStatus.data.is_finish = newStatus.is_finish;
          newStatus.data.is_closing_status = newStatus.is_closing_status;
          newStatus.data.is_universal = newStatus.is_universal;
          newStatus.data.to_archive = newStatus.to_archive;

         // void this.graphService.changeNode(newStatus);
          this.modalService.openTemplateModal(this.settingsNodeView);
          this.clearModalData();
        });
    }

    clearModalData(): void {
        this.step = 'selectBoard';
        this.outputDashboard = null;
        this.outputStatus = null;
        this.inputDashboard = null;
    }

    selectModalBoard(board: string, output: boolean): void {
        this.crmService.getBoardByAlias(board).subscribe(res => {
            if (output) {
                this.outputDashboard = res.board;
                this.inputBoards = this.taskOptionsService.boards.filter(x => x.id !== this.outputDashboard!.id);
            } else {
                this.inputDashboard = res.board;
            }
        });
    }

    selectOutputStatus(status: string): void {
        this.outputStatus = this.outputDashboard!.status_node_settings_of_member.filter(
            x => x.status_node.id.toString() === status)[0].status_node;
    }

    deleteEdge(edge: Edges): void {
        /*         if (!this.isDeleteMode) {
                    return;
                } */
 /*        const outputNodeId: string = edge.data.source.substring(1);
        const targetNode: Nodes = this.graphData.nodes.filter(node => node.id === edge.data.target)[0];

        const targetBoardAlias: string|undefined = targetNode?.data?.parent?.substring(2);
        const oneEdge: boolean = this.graphData.edges.filter(edg => edg.data.target === edge.data.target).length === 1;

        const modalSettings = {
            modalHeader: this.translate.instant('CONFIRM.HEADERS.DELETE'),
            modalBody: this.translate.instant('CONFIRM.TEXT.DELETE_LINK'),
            buttonSubmit: this.translate.instant('CONFIRM.BUTTONS.YES'),
            buttonClose: this.translate.instant('CONFIRM.BUTTONS.NO'),
        };
        const modal = this.modalService.createFromSettings(modalSettings);
        modal.result.then((data : any) => {
            if (data) {
                this.crmService.deleteLinkBetweenBoards(outputNodeId, targetBoardAlias!).subscribe({
                    next: res => {
                        this.openGraph();
                        this.alert.setAlert(res.message, 'green');

                        if (oneEdge) {
                            setTimeout(() => {
                                this.deleteNode(targetNode, targetBoardAlias!);
                            }, 500);
                        }
                    }, error: err => {
                        this.alert.setAlert(err.message, 'blue');
                    },
                });
            }
        }).catch(() => {
            return;
        }); */
    }

    switchMode(): void {
        this.isDeleteMode = !this.isDeleteMode;
        this.openGraph();
    }

    deleteNode(node: any, targetBoardAlias: string): void {
        const modalSettings = {
            modalHeader: this.translate.instant('CONFIRM.HEADERS.DELETE'),
            modalBody: this.translate.instant('CONFIRM.TEXT.DELETE_STATUS', {name: node.data.name}),
            buttonSubmit: this.translate.instant('CONFIRM.BUTTONS.YES'),
            buttonClose: this.translate.instant('CONFIRM.BUTTONS.NO'),
        };
        const modal = this.modalService.createFromSettings(modalSettings);
        modal.result.then((data:any) => {
            if (data) {
                this.boardWithDeletingStatus = this.allBoards.filter((board:any) => board.alias === targetBoardAlias)[0];
                this.statusesOfDeletedBoard = this.allBoards.filter((board:any) =>
                    board.alias === targetBoardAlias)[0].status_nodes.filter((nodes:any) => nodes.id !== node.id);
                this.deleteStatus = node.data.node;
                this.modalService.openTemplateModal(this.deleteStatusNode);
            }
        }).catch(() => {
            return;
        });
    }

    onDeleteStatus(statusName: string, modal: NgbModalRef): void {
        if (statusName !== this.deleteStatus.label) {
            return this.alert.setAlert(this.translate.instant('ALERTS.NAME_ERROR'), 'blue');
        }
        if (!this.selectedStatus) {
            return this.alert.setAlert(this.translate.instant('ALERTS.STATUS_ERROR'), 'blue');
        }
        this.isLockButton = true;
        this.crmService.deleteNode(
            this.deleteStatus.id,
            this.selectedStatus.id,
        ).subscribe({
            next: res => {
                this.alert.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'green');
                void this.graphService.selectBoard(res.board, true, false);
                this.isLockButton = false;
                modal.close();
            }, error: error => {
                this.isLockButton = false;
                this.alert.setAlert(error.message, 'blue');
            },
        });
    }

    saveNode(modal: NgbModalRef): void {
        if (!this.graphService.selectNode!.label) {
            return this.alert.setAlert(this.translate.instant('ALERTS.SET_NAME'), 'blue');
        }

        const statusIconData = {
            backgrCol: this.graphService.selectNode!.data?.backgrCol||'',
            svg: structuredClone(this.graphService.selectNode!.data?.svg)
        };

        const data = {
            label: this.graphService.selectNode!.label,
            description: this.graphService.selectNode!.data?.description||'',
            is_successful: this.graphService.isSuccessful,
            to_archive: this.graphService.toArchive,
            is_universal: this.graphService.isUniversal,
            data: JSON.stringify(statusIconData),
        };

        this.crmService.updateNode(this.graphService.selectNode!.id, data).subscribe({
            next: res => {
                void this.graphService.selectBoard(res.board, true, false);
                modal.close();
                this.alert.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'green');
            }, error: error => {
                this.alert.setAlert(error.message, 'blue');
                modal.close();
            },
        });
    }
}
